import React from 'react';
import styled from 'styled-components';
import { MapPin } from 'lucide-react';
import { Badge } from '../shared/ui';
import { standorte, zusatzgebiete } from '../data/standorte';
import EinsatzgebietMap from './EinsatzgebietMap';

const StandorteBox = styled.div`
  text-align: center;
  margin-top: 3rem;
`;
const StandorteTitle = styled.h2`
  font-size: 1.8rem;
  font-weight: 700;
  color: var(--brand);
  margin: 1rem 0 0.75rem;
`;
const StandorteText = styled.p`
  max-width: 680px;
  margin: 0 auto 1.75rem;
  color: #3a4662;
  line-height: 1.6;
`;
const StandorteGrid = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 0.6rem;
  max-width: 820px;
  margin: 0 auto;
`;
const StandortChip = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  background: #fff;
  border: 1px solid #e3eaf5;
  border-radius: 999px;
  padding: 0.45em 1em;
  font-size: 0.95rem;
  font-weight: 600;
  color: #2b3652;
  box-shadow: 0 2px 10px rgba(0, 52, 196, 0.06);
  svg {
    color: var(--brand);
  }
`;
const ZusatzChip = styled(StandortChip)`
  background: #f6f8fc;
  color: #55617d;
  svg {
    /* #8593ad kam auf dem hellen Chip nur auf 2,9:1 - fuer bedeutungstragende
       Grafik verlangt WCAG AA 3:1. */
    color: #7a89a6;
  }
`;
const ZusatzLabel = styled.div`
  margin: 1.75rem 0 0.75rem;
  font-size: 0.9rem;
  font-weight: 700;
  color: #55617d;
  text-transform: uppercase;
  letter-spacing: 0.4px;
`;

const StandorteSection: React.FC<{ showHeader?: boolean }> = ({ showHeader = true }) => (
  <StandorteBox>
    {showHeader && (
      <>
        <Badge>Einsatzgebiet</Badge>
        <StandorteTitle>Unsere Standorte &amp; Einsatzgebiete</StandorteTitle>
        <StandorteText>
          Von Gütersloh aus sind wir in Bielefeld, Gütersloh und der gesamten Umgebung für Sie im Einsatz – mit kurzen Anfahrtswegen und persönlicher Betreuung.
        </StandorteText>
      </>
    )}
    <StandorteGrid>
      {standorte.map((ort) => (
        <StandortChip key={ort.name}>
          <MapPin style={{ height: 15, width: 15 }} />
          {ort.name}
        </StandortChip>
      ))}
    </StandorteGrid>
    <ZusatzLabel>Zusatzgebiete auf Anfrage</ZusatzLabel>
    <StandorteGrid>
      {zusatzgebiete.map((ort) => (
        <ZusatzChip key={ort.name}>
          <MapPin style={{ height: 15, width: 15 }} />
          {ort.name}
        </ZusatzChip>
      ))}
    </StandorteGrid>
    <EinsatzgebietMap />
  </StandorteBox>
);

export default StandorteSection;
